abstract class AbstractObservable<T = any, K = string> {
  private _state: T
  private _subscribers: Map<K, (state: T) => void>

  constructor(initialState: T) {
    this._state = initialState
    this._subscribers = new Map()
  }

  get state() {
    return this._state
  }

  subscribe(key: K, callback: (state: T) => void, ping = true) {
    this._subscribers.set(key, callback)
    if (ping) this._subscribers.get(key)(this._state)
  }

  unsubscribe(key: K) {
    this._subscribers.delete(key)
  }

  protected notifySubscribers() {
    this._subscribers.forEach((callback) => callback(this._state))
  }

  update(value: T) {
    this._state = value
    this.notifySubscribers()
  }
}

export default AbstractObservable
